// extracted by mini-css-extract-plugin
module.exports = {"container":"JobContent_container__D8TMG","body":"JobContent_body__1O_Cn","notice":"JobContent_notice__2xsik","sending":"JobContent_sending__3OYaB"};